module.exports = "../study/imgs/maps/Kanagawa/S8/Hazard/Beach/Kanagawa_Beach_MRI_RCP85_End.png";